import type { SVGProps } from "react";
import { memo } from "react";
const NICEDCV = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M61.07 38.386c-4.743 2.959-11.353 5.967-18.61 8.469-5.12 1.765-10.13 3.123-14.595 3.983 3.862 9.842 11.08 16.199 18.112 15.015 6.537-1.103 11.41-8.76 12.123-19.052l1.996.138c-.792 11.408-6.203 19.606-13.787 20.886-.66.112-1.325.166-1.986.166-7.378 0-14.605-6.782-18.452-16.797a60 60 0 0 1-3.287.459q-2.116.226-3.815.226c-3.819 0-6.043-.854-6.628-2.551-.727-2.11 1.355-4.762 6.187-7.883l1.086 1.68c-4.71 3.042-5.6 4.921-5.382 5.552.231.671 2.247 1.636 8.34.988a57 57 0 0 0 2.815-.385 43 43 0 0 1-1.54-6.252c-1.24-7.355-.59-14.59 1.833-20.374 2.49-5.939 6.551-9.664 11.437-10.488 5.886-.995 12.158 2.525 16.762 9.413l-1.662 1.111c-4.155-6.214-9.668-9.41-14.768-8.552-4.186.706-7.71 4.005-9.924 9.289-2.279 5.439-2.885 12.282-1.705 19.268a41.6 41.6 0 0 0 1.553 6.242c4.445-.837 9.478-2.195 14.634-3.972 7.12-2.455 13.585-5.393 18.203-8.276 5.197-3.242 6.191-5.245 5.96-5.917-.2-.583-1.875-1.473-6.873-1.119l-.14-1.996c5.214-.368 8.214.459 8.903 2.463.76 2.2-1.526 4.981-6.79 8.266"
      />
    </g>
  </svg>
);
const Memo = memo(NICEDCV);
export default Memo;
